var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCat207(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cat_207"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "_207",
    "data-name": 207,
    className: "cls-2",
    d: "M79.89,96.14c9.48-8-1.37-30-5.17-38.3A165.39,165.39,0,0,0,52.27,22C47.14,15.73,34.17-2.12,24.33,2.1c-10.69,4.59-8.06,26.38-6.71,35.18,3,19.3,12.71,37.73,28.54,49.46C53.31,92,71.18,103.51,79.89,96.14Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat207);
export default __webpack_public_path__ + "static/media/cat_207.9b51131cad4e9cf7db836110c07198c5.svg";
export { ForwardRef as ReactComponent };